import React from "react";
import { useIntl, defineMessages } from "react-intl";
import Modal from "theme/components/organisms/Modal";
import ProductAddedPopInContent from "./ProductAddedPopInContent";
import ProductAddedPopInActions from "./ProductAddedPopInActions";

export const messages = defineMessages({
  modalTitle: {
    id: "modules.ProductAddedPopIn.modalTitle",
    defaultMessage: "Product added to cart",
  },
  title: {
    id: "modules.ProductAddedPopIn.youAdded",
    defaultMessage: "You just added the following product(s) to your cart:",
  },
});

const ProductAddedPopIn = (props) => {
  const intl = useIntl();
  return (
    <Modal
      isOpen={Boolean(props.product)}
      onRequestClose={props.hidePopin}
      contentLabel={intl.formatMessage(messages.modalTitle)}
      title={intl.formatMessage(messages.title)}
      actions={<ProductAddedPopInActions hidePopin={props.hidePopin} />}
    >
      <>
        {props.product && (
          <ProductAddedPopInContent
            product={props.product}
            hidePopin={props.hidePopin}
          />
        )}
      </>
    </Modal>
  );
};

export default ProductAddedPopIn;
